import React, { useReducer, useEffect } from "react";
import JoyRide, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { isUndefined } from "util";
import { Button }from "@shopify/polaris";

// Define the steps
const TOUR_STEPS = [
    {
      target: "#dashboard",
      content:"Get all the Analytics about Products, Orders & Plans",
      disableBeacon: true,
    },
    {
      target: "#products",
      content:"Get all the Information about your Products in App, Status & Errors",
    },
    {
      target: "#orders",
      content:"Get all the Information about your Orders received from eBay and their status",
    },
    {
      target: "#businessPolicy",
      content:"Create & Edit Business Policies (Shipping, Payment & Returns)",
    },
    {
      target: "#templates",
      content:"Create & Edit Templates (Category, Inventory, Pricing & Title)",
    },
    {
      target: "#profiles",
      content:"Profiles created for your products will appear here. You can also Edit Profiles from this section.",
    },
    {
      target: "#configuration",
      content:"In this section, you will have all the settings related to functionality of App",
    },
    {
      target: "#activities",
      content:"All the running and completed activities will appear in this section",
    },
    {
      target: "#help",
      content:"In this section, you may check FAQs and Help Videos related to App",
    },
    {
      target: "#plans",
      content:"Select subscription plan from this section",
    },
    {
      target: "#contactUs",
      content:"In this section, You may schedule a Demo, Live Chat, Whatsapp, or Email Us.",
    }
  ];

// Define our state
const INITIAL_STATE = {
  key: new Date(),
  run: false,
  continuous: true,
  loading: false,
  stepIndex: 0,
  steps: TOUR_STEPS,
};

// Set up the reducer function
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "START":
      return { ...state, run: true };
    case "RESET":
      return { ...state, stepIndex: 0 };
    case "STOP":
      return { ...state, run: false,stepIndex:0 };
    case "NEXT_OR_PREV":
      return { ...state, ...action.payload };
    case "RESTART":
      return {
        ...state,
        stepIndex: 0,
        run: true,
        loading: false,
        key: new Date(),
      };
    default:
      return state;
  }
};

// Define the Tour component
const NavigationTour = (props) => {

  // console.log(props.tourOpen)
  const [tourState, dispatch] = useReducer(reducer, INITIAL_STATE);
  useEffect(() => {
    if (!localStorage.getItem("tour") && props.tourOpen ){
      dispatch({ type: "START" });
    }
  }, [props]);

  const callback = (data) => {
    const { action, index, type, status } = data;
    if (
      action === ACTIONS.CLOSE ||
      (status === STATUS.SKIPPED && tourState.run) ||
      status === STATUS.FINISHED
    ) {
      dispatch({ type: "STOP"});
      props.handleTourOpen(false)
    } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      dispatch({
        type: "NEXT_OR_PREV",
        payload: { stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) },
      });
    }
  };

  // const startTour = () => {
  //   dispatch({ type: "RESTART" });
  // };

  return (
    <>
      {/* <button className="btn btn-primary" onClick={startTour}>
        Start Tour
      </button> */}
      <JoyRide
        {...tourState}
        callback={callback}
        showSkipButton={true}
        styles={{
          tooltipContainer: {
            textAlign: "left",
          },
          buttonNext:{
            backgroundColor:"#1072C6"
          },
          buttonBack: {
            marginRight: 10,
            color:"black"
          },
          spotlight:{
            width:'250px'
          }
        }}
        locale={{
          last: "End tour",
        }}
      />
      <div className="floating-right-bottom-btn">
      {window.innerWidth >= 1024 &&
          <Button primary={true} onClick={()=>props.handleTourOpen(true)}>Take a tour</Button>
      }
      </div>
    </>
  );
};
export default NavigationTour;
